export const CS: string = 'cs';
export const EN: string = 'en';
export const DE: string = 'de';
export const ES: string = 'es';
export const RU: string = 'ru';
export const LOCAL_STORAGE_LANG = 'LANG';
export enum Languages {CS='cs', EN='en', DE='de', ES='es', RU='ru'};